import type { MenuOption } from "naive-ui";

export const menuUtil = function (t: any): MenuOption[] {
  const menuOptions: MenuOption[] = [
    {
      key: "dashboard",
      label: t("dashboard"),
    },
    {
      key: "company",
      label: t("company"),
      type: "group",
      children: [
        {
          key: "office",
          label: t("office"),
        },
        {
          key: "structure",
          label: t("structure"),
          type: "group",
          children: [
            {
              key: "department",
              label: t("department"),
            },
            {
              key: "section",
              label: t("section"),
            },
            {
              key: "level",
              label: t("level"),
            },
            {
              key: "position",
              label: t("position"),
            },
          ],
        },
      ],
    },
  ];

  return menuOptions;
};
